// Import Constants
import { ScheduleModalViews } from 'constants/common';

export const ScheduleModalView = {
    mainView: {
        key: ScheduleModalViews.mainView,
    },
    hourlyView: {
        key: ScheduleModalViews.hourlyView,
        isVisibleSave: true,
        isVisibleHour: true,
    },
    dailyView: {
        key: ScheduleModalViews.dailyView,
        isVisibleSave: true,
        isVisibleDay: true,
    },
    weeklyView: {
        key: ScheduleModalViews.weeklyView,
        isVisibleSave: true,
        isVisibleWeek: true,
    },
    monthlyView: {
        key: ScheduleModalViews.monthlyView,
        isVisibleSave: true,
        isVisibleDay: true,
        isVisibleMonth: true,
    },
    annuallyView: {
        key: ScheduleModalViews.annuallyView,
        isVisibleSave: true,
        isVisibleDay: true,
        isVisibleMonth: true,
        isVisibleYear: true,
    },
    notRepeatView: {
        key: ScheduleModalViews.notRepeatView,
    },
};

export const EmilRecipientStatus = {
    Normal: 0,
    Hidden: 1,
    Deactivated: 2,
    Deleted: 3,
    0: 'Normal',
    1: 'Hidden',
    2: 'Deactivated',
    3: 'Deleted',
};

export const EmailRecipientStatusColors = {
    [EmilRecipientStatus.Normal]: '#207ede',
    [EmilRecipientStatus.Hidden]: '#9171cb',
    [EmilRecipientStatus.Deactivated]: '#616161',
    [EmilRecipientStatus.Deleted]: '#c50324',
};
